import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Item from '../Form/Item/index.js';
import Row from '../Form/Row/index.js';
import HelpPopover from '../HelpPopover/index.js';

const Fieldset = ({
  bottomSpacing,
  children,
  className,
  description,
  helpIcon,
  isOptional,
  isRequired,
  popoverText,
  popoverTitle,
  testSection,
  title,
  titleSize,
  ...props
}) => {
  const headerClasses = classNames({
    epsilon: titleSize === "small",
    gamma: titleSize === "large",
    "oui-label--required": isRequired,
    "push--bottom": titleSize === "large",
    "push-half--bottom": titleSize === "small"
  });
  const fieldsetClasses = classNames(
    "axiom-fieldset",
    {
      "flush--bottom": !bottomSpacing,
      "push-triple--bottom": bottomSpacing
    },
    className
  );
  return /* @__PURE__ */ jsxs(
    "fieldset",
    {
      className: fieldsetClasses,
      "data-test-section": testSection,
      ...props,
      children: [
        title && /* @__PURE__ */ jsxs("legend", { className: headerClasses, children: [
          title,
          isOptional && /* @__PURE__ */ jsx("label", { className: "oui-label__optional", children: "(Optional)" }),
          helpIcon && /* @__PURE__ */ jsx(
            HelpPopover,
            {
              horizontalAttachment: "left",
              popoverTitle,
              verticalAttachment: "middle",
              children: /* @__PURE__ */ jsx("p", { children: popoverText })
            }
          )
        ] }),
        description && /* @__PURE__ */ jsx("div", { className: "push--bottom", children: description }),
        children
      ]
    }
  );
};
Fieldset.Row = Row;
Fieldset.Item = Item;
Fieldset.propTypes = {
  /** Adds spacing at the bottom. If used in a Form, make this to true. */
  bottomSpacing: PropTypes.bool,
  /** Children components. Should be Fieldset.Row or Fieldset.Item for proper spacing */
  children: PropTypes.node.isRequired,
  /** CSS class names. */
  className: PropTypes.string,
  /** Description for Fieldset */
  description: PropTypes.node,
  /** Indicates whether to include a help popover */
  helpIcon: PropTypes.bool,
  /** Indicates whether to include the "optional" tag to the fieldset */
  isOptional: PropTypes.bool,
  /** Indicates whether to include a required asterisk */
  isRequired: PropTypes.bool,
  /** Text for popover */
  popoverText: PropTypes.string,
  /** Title for popover */
  popoverTitle: PropTypes.string,
  testSection: PropTypes.string,
  /** Title for Fieldset */
  title: PropTypes.string,
  /** Size of Fieldset title*/
  titleSize: PropTypes.oneOf(["small", "large"])
};
Fieldset.defaultProps = {
  bottomSpacing: true,
  titleSize: "large"
};

export { Fieldset as default };
